import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n/config";
import axios from "axios";
import { handleAuthFailureStatus } from "./services/authFailureRedirect";

// Global auth failure handling:
// - Any API call returning 401/403 clears stored auth and redirects to /login.
// This keeps the app consistent even if a token expires mid-session.
(() => {
  const originalFetch: typeof window.fetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    handleAuthFailureStatus(response.status);
    return response;
  };

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      handleAuthFailureStatus(error?.response?.status);
      return Promise.reject(error);
    },
  );
})();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
